// extracted by mini-css-extract-plugin
export var linkText = "_q5-0";